import { mpstopicfile } from "./guidelines";

/**
 * Gets the 3-letter abbreviation for a guideline
 */
export const getGuidelineAbbreviation = (guidelineName) => {
  const normalisedName = guidelineName.replace(/ /g, "_");

  const guidelineInfo = mpstopicfile[normalisedName];

  if (!guidelineInfo || !guidelineInfo.topiccode) {
    console.warn(`No abbreviation found for guideline: ${guidelineName}`);
    return null;
  }

  const abbreviation = guidelineInfo.topiccode.substring(0, 3).toUpperCase();

  return abbreviation;
};

/**
 * Gets a mapping of all guideline names to their abbreviations
 */
export const getGuidelineAbbreviationMap = () => {
  const abbreviationMap = {};

  Object.keys(mpstopicfile).forEach((guidelineName) => {
    const abbreviation = getGuidelineAbbreviation(guidelineName);
    if (abbreviation) {
      abbreviationMap[guidelineName] = abbreviation;
    }
  });

  return abbreviationMap;
};

/**
 * Gets the DITA Updates map path for a guideline
 */
export const getGuidelineUpdatesDitamapPath = (guidelineName) => {
  const abbreviation = getGuidelineAbbreviation(guidelineName);

  if (!abbreviation) {
    return null;
  }

  return `Updates/Updates_${abbreviation}.ditamap`;
};

export const GUIDELINE_ABBREVIATIONS = {
  Addiction_Medicine: "AMG",
  Antibiotic: "ABG",
  Bone_and_Metabolism: "BMG",
  Cardiovascular: "CVG",
  Dermatology: "DMG",
  Developmental_Disability: "DDG",
  Diabetes: "DBG",
  Fatigue: "FTG",
  Gastrointestinal: "GIG",
  Kidney_and_Urinary: "KUG",
  Sleep_Disorder: "SLG",
  Liver_Disorders: "LDG",
  Neurology: "NRG",
  Oral_and_Dental: "DTG",
  Other: "OTH",
  Pain_and_Analgesia: "AGG",
  Palliative_Care: "PCG",
  Psychotropic: "PTG",
  Respiratory: "RSG",
  Rheumatology: "RHG",
  Sexual_and_Reproductive_Health: "SRG",
  Toxicology_and_Toxinology: "TTG",
  Ulcer_and_Wound_Management: "LWG",
  Wilderness_Medicine: "WMG",
};
